import { TrackDef } from '../track.js';

/**
 * NULLSPIRE — The void, expert.
 * The league's final examination: a full-twist corkscrew down the spire's
 * throat, a knife of a chicane at width twenty, and a narrow rift shortcut
 * that pays two seconds to anyone brave enough to thread it.
 */
export const nullspire: TrackDef = {
  id: 'nullspire',
  name: 'Nullspire',
  tagline: 'A full-twist helix, a chicane with teeth, and a shortcut for the brave. The void keeps score.',
  environment: 'voidgate',
  difficulty: 4,
  layout: 'circuit',
  defaultLaps: 2,
  width: 28,
  unlockLevel: 13,
  points: [
    { x: -190, y: 60, z: -80, width: 30 },
    { x: -110, y: 62, z: 80, width: 30, roll: 0 },
    { x: -80, y: 63, z: 320, width: 30, roll: 1.57 },
    { x: -50, y: 64, z: 560, width: 30, roll: 3.14 },
    { x: -20, y: 65, z: 800, width: 30, roll: 4.71 },
    { x: 10, y: 66, z: 1040, width: 30, roll: 6.28 },
    { x: 120, y: 68, z: 1290, width: 28, roll: -0.2 },
    { x: 350, y: 72, z: 1410, width: 26, roll: -0.3 },
    { x: 590, y: 69, z: 1340, width: 24, roll: -0.3 },
    { x: 680, y: 62, z: 1100, width: 24, roll: -0.25 },
    { x: 520, y: 55, z: 860, width: 24, roll: -0.2 },
    { x: 250, y: 51, z: 780, width: 22 },
    { x: 130, y: 48, z: 750, width: 20, roll: 0.3 },
    { x: 110, y: 46, z: 650, width: 20, roll: 0.35 },
    { x: 200, y: 45, z: 570, width: 20, roll: 0.3 },
    { x: 330, y: 45, z: 550, width: 20, roll: -0.3 },
    { x: 400, y: 46, z: 440, width: 20, roll: -0.35 },
    { x: 380, y: 48, z: 300, width: 22 },
    { x: 290, y: 52, z: 40, width: 26 },
    { x: 140, y: 56, z: -180, width: 28, roll: -0.2 },
    { x: -70, y: 59, z: -330, width: 28, roll: -0.3 },
    { x: -260, y: 61, z: -280, width: 28, roll: -0.35 },
  ],
  branches: [
    {
      name: 'rift cut',
      entryS: 0.379,
      exitS: 0.522,
      points: [
        { x: 300, y: 71, z: 1360 }, // tangent handle
        { x: 470, y: 71, z: 1390, width: 16 },
        { x: 545, y: 66, z: 1230, width: 15 },
        { x: 580, y: 60, z: 1060, width: 15 },
        { x: 565, y: 56, z: 930, width: 16 },
        { x: 520, y: 55, z: 870, width: 16 },
        { x: 419, y: 52, z: 789 }, // tangent handle
      ],
    },
  ],
  features: [
    { kind: 'boost', s: 0.015, length: 0.007, lane: 0 },
    { kind: 'boost', s: 0.04, length: 0.007, lane: 0 },
    { kind: 'zone', s: 0.06, length: 0.21, name: 'helix' },
    { kind: 'noWalls', s: 0.26, length: 0.04, side: 'both' },
    { kind: 'boost', s: 0.44, length: 0.007, lane: -0.3 },
    { kind: 'zone', s: 0.61, length: 0.14, name: 'rift' },
    { kind: 'jump', s: 0.77, length: 0.01 },
    { kind: 'boost', s: 0.83, length: 0.007, lane: 0.3 },
    { kind: 'boost', s: 0.9, length: 0.007, lane: 0 },
  ],
  medals: { bronze: 65.3, silver: 56.2, gold: 50.2, author: 46.7 },
};
